import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderFooterVisibilityService {
  public isHeaderVisible$ = new BehaviorSubject<boolean>(true);
  public isFooterVisible$ = new BehaviorSubject<boolean>(true);

  public set isHeaderVisible(value) {
    this.isHeaderVisible$.next(value);
  }

  public get isHeaderVisible() {
    return this.isHeaderVisible$.value;
  }

  public set isFooterVisible(value) {
    this.isFooterVisible$.next(value);
  }

  public get isFooterVisible() {
    return this.isFooterVisible$.value;
  }
}
